export class Subscriber<T> {
  private _callbacks: ((e: T) => void)[] = [];
  private _currentItem: T;
  private _nextItem: T | undefined;
  private _allScheduled: boolean = false;
  private _scheduledItems: ((e: T) => void)[] | undefined;
  private _timerId: number | undefined;

  constructor(initialItem: T) {
    this._currentItem = initialItem;
  }

  private _scheduleUpdate() {
    if (this._timerId) {
      return;
    }
    // FIXME: node typings leakage
    // @ts-ignore
    this._timerId = setTimeout(() => this._notify(), 0);
  }

  private _notify() {
    const current = this._nextItem ?? this._currentItem;
    const scheduled = this._scheduledItems;
    this._currentItem = current;
    this._nextItem = undefined;
    this._scheduledItems = undefined;
    this._timerId = undefined;
    if (this._allScheduled) {
      this._allScheduled = false;
      for (const cb of this._callbacks) {
        if (this._callbacks.includes(cb)) {
          cb(current);
        }
      }
    } else if (scheduled) {
      for (const cb of scheduled) {
        cb(current);
      }
    }
  }

  subscribe(cb: (e: T) => void) {
    if (this._callbacks.indexOf(cb) === -1) {
      this._callbacks.push(cb);
    }
    if (!this._allScheduled && !this._scheduledItems?.includes(cb)) {
      this._scheduledItems = [...(this._scheduledItems || []), cb];
      this._scheduleUpdate();
    }
    return () => {
      this.unsubscribe(cb);
    };
  }

  unsubscribe(cb: (e: T) => void) {
    this._callbacks = this._callbacks.filter((item) => item !== cb);
  }

  get currentItem() {
    return this._currentItem;
  }

  next(item: T) {
    this._allScheduled = true;
    this._nextItem = item;
    this._scheduleUpdate();
  }
}
